import { useClickOutside } from '@/helpers/useClickOutside'
import { TableForm } from './TableForm'
import { TableFormPlaceholder } from './TableFormPlaceholder'
import { UseFormReturn } from 'react-hook-form'
import { InputFormValues } from '@/modules/CombinedLogs/types'
import { RowSelectionState, Table } from '@tanstack/react-table'
import { Log } from '@/types/logs'
import { useHandleHotkeys } from '@/modules/CombinedLogs/hooks/useHandleHotkeys'
import { useCombinedLogsTableFormStateStore } from '@/modules/CombinedLogs/store'
import { Table as TableComponent, TableColGroup } from '@/ui/Table'
import styles from '../../CombinedLogs.module.scss'

interface CreateLogFormProps {
    form: UseFormReturn<InputFormValues>
    isCreateFormActive: boolean
    setIsCreateFormActive: (value: boolean) => void
    table: Table<Log>
    onSubmit: (data: InputFormValues) => void
    setRowSelection: (value: RowSelectionState) => void
}

export const CreateLogForm = ({
    form,
    isCreateFormActive,
    setIsCreateFormActive,
    table,
    onSubmit,
    setRowSelection,
}: CreateLogFormProps) => {
    const { clearInputValues } = useCombinedLogsTableFormStateStore()
    const handleOpenForm = () => {
        setIsCreateFormActive(true)
        form.reset({
            timeStamp: '',
            routes: '',
            code: '',
            run: '',
            duty: '',
            fleet: '',
            trip: '',
            bulkCurtailmentTripTo: '',
            rtnTrips: '',
            mileage: '',
            isZeroMileage: 'false',
            author: '',
            locationFrom: '',
            description: '',
        })
        setRowSelection({})
        clearInputValues()
    }

    useHandleHotkeys(handleOpenForm)

    const handleClickAwayFromForm = () => {
        if (isCreateFormActive && form.formState.isDirty && Object.keys(form.formState.dirtyFields).length > 0) {
            form.handleSubmit(onSubmit)()
        }
        setIsCreateFormActive(false)
    }

    const wrapperRef = useClickOutside<HTMLDivElement>(handleClickAwayFromForm, true)

    return (
        <div ref={wrapperRef} className={styles.createFormWrapper}>
            <TableComponent className={styles.table}>
                <TableColGroup table={table} />
                <tbody>
                    <TableForm isActive={isCreateFormActive} form={form} table={table} />
                    <TableFormPlaceholder isActive={isCreateFormActive} handleClick={handleOpenForm} table={table} />
                </tbody>
            </TableComponent>
        </div>
    )
}
